import * as moment from 'moment';
/**
 * Create an interval array of moments from given start, end moment object.
 * The end will be exclused from the return.
 *
 * @param start Inclusive
 * @param end Exclusive
 * @param multiplier
 * @param granularity
 * @param formatOutput
 */
export function createIntervalsFromRange(start, end, multiplier, granularity, formatOutput) {
    if (multiplier === void 0) { multiplier = 1; }
    if (granularity === void 0) { granularity = 'days'; }
    if (formatOutput === void 0) { formatOutput = null; }
    var intervals = [];
    var _start = moment(start);
    while (!_start.isSameOrAfter(moment(end), granularity)) {
        if (formatOutput) {
            intervals.push(_start.format(formatOutput));
        }
        else {
            intervals.push(_start);
        }
        _start = moment(_start).add(multiplier, granularity);
    }
    return intervals;
}
/**
 * Detect span from given range string
 *
 * @param range The range is expected in a ISO start and end, that are separated by underscore,for example 2018-01-9_2019-02-01
 * @param yearsDay The number of days of year
 * @throws Error if range is not valid
 */
export function detectSpanFromRange(range, yearsDay) {
    if (yearsDay === void 0) { yearsDay = 367; }
    var start;
    var end;
    var period = 1;
    var interval = 'day';
    var result = range.split('_');
    if (result.length !== 2) {
        throw new Error('Invalid range format');
    }
    var now = moment().utc();
    start = moment.utc(result[0]);
    end = moment.utc(result[1]);
    if (!start.isValid()) {
        throw new Error('Start is not valid');
    }
    if (!end.isValid()) {
        throw new Error('End is not valid');
    }
    if (end.diff(start, 'days') < 1) {
        throw new Error('End is before or equal start');
    }
    if (end.diff(now, 'days') > 0) {
        throw new Error('End is in the future');
    }
    if (start.year() < 1900) {
        throw new Error('Start is before 1900');
    }
    if (end.diff(start, 'year') >= 100) {
        interval = 'year';
        period = 1;
    }
    else if (end.diff(start, 'year') >= 30) {
        interval = 'month';
        period = 3;
    }
    else if (end.diff(start, 'year') >= 10) {
        interval = 'month';
        period = 1;
    }
    else if (end.diff(start, 'year') >= 5) {
        interval = 'week';
        period = 2;
    }
    else if (end.diff(start, 'day') >= yearsDay) {
        interval = 'week';
        period = 1;
    }
    return {
        start: start,
        end: end,
        interval: interval,
        period: period,
    };
}
/**
 * Simple detect of 24/7 open and close trading event
 *
 * @param openEvent
 * @param closeEvent
 */
export function areOpenAndCloseEvents(openEvent, closeEvent) {
    var diff = closeEvent.diff(openEvent, 'hours');
    return diff >= 1 && diff <= 12 && openEvent.isSame(closeEvent, 'day');
}
//# sourceMappingURL=moment.js.map